import React from 'react';
import PropTypes from "prop-types";

import Table from '../../common/Table';

const FinancieelTableComponent = (props) => {
    const {
        settings,
        disabled
    } = props;

    if (!settings.hasRows) return <p>{settings.noModelsContent}<br /><br /></p>;

    return (
        <Table headers={settings.tableHeaders} headerSizes={settings.tableHeaderSizes}>
            {settings.tableRows}
        </Table>
    );
};

FinancieelTableComponent.propTypes = {
    settings: PropTypes.object.isRequired,
    disabled: PropTypes.bool
};

export default FinancieelTableComponent;